import type { BoardScope } from '../../api/boards';

/**
 * 게시판 첨부가 **어느 용량에서 나가는지** — 화면 안내 문구용 (2026-08-19).
 *
 * 서버 `apps/chat-server/src/modules/board/board-quota.ts` 의 `fileScopeOfBoard` 를
 * 그대로 비추는 표다. 판정 자체는 언제나 서버가 하고(업로드 한도 검사·files 스코프 기록),
 * 여기서는 **올리기 전에 알려 주기 위한 문구**만 고른다.
 *
 * ⚠ 부서(DIVISION) 게시판은 회사로 접힌다 — workspace_quotas 에 부서 스코프가 없다.
 *   서버 표가 바뀌면 여기도 같이 바꿔야 한다(양쪽 다 네 갈래를 전부 다룬다).
 */
export type BoardQuotaScope = 'company' | 'team' | 'personal';

export function boardQuotaScopeOf(scopeType: BoardScope): BoardQuotaScope {
  switch (scopeType) {
    case 'COMPANY':
    case 'DIVISION':
      return 'company';
    case 'TEAM':
      return 'team';
    default:
      return 'personal';
  }
}

/** 안내 문구 i18n 키. `tBoards(boardQuotaNoticeKey(board.scopeType))` 로 쓴다. */
export function boardQuotaNoticeKey(scopeType: BoardScope): string {
  return `boards.attach.quota.${boardQuotaScopeOf(scopeType)}`;
}
